export class ApiError<T = unknown> extends Error {
  status: number;

  response: T;

  constructor(message: string, status: number, response: T) {
    super(message);
    this.status = status;
    this.response = response;
  }
}
